export default {
    title: "Nastavenia účtu - DOFFERO®",
    mainucet_text_0: "Nastavenia účtu",
    mainucet_text_1:
        "Nastav si základné údaje , ktoré sa týkajú najmä tvojho účtu.",
    mainucet_text_2: "Osobné údaje",
    mainucet_text_3: "Tvoje IP adresy",
    mainucet_text_4:
        "Nastav si IP adresy, z ktorých nebudeme počítať otvorenie tvojej ponuky.",
    mainucet_text_5: "Uložiť",
    mainucet_text_6: "Zmena hesla",
    mainucet_text_7: "Zrušenie účtu",
    mainucet_text_8: "Chceš si zrušiť účet na DOFFERO? To nás veľmi mrzí.",
    mainucet_text_9: "Napíš mi e-mail na",
    mainucet_text_10: "a účet ti zrušíme čím skôr.",
    ipaddress_text_0: "Vložiť aktuálnu IP adresu",
    ipaddress_text_1: "Ip adresa",
    ipaddress_text_2: "Uložiť",
    ipaddress_text_3: "Ip adresa bola pridaná",
    ipaddress_text_4: "Ip adresa bola odstránená",
    osobneudaje_text_0: "meno",
    osobneudaje_text_1: "priezvisko",
    osobneudaje_text_2: "e-mail",
    osobneudaje_text_3:
        "Registračný e-mail nie je možné zmeniť. V prípade potreby ma kontaktuj na",
    osobneudaje_text_4: "help@doffero.com",
    zmenahesla_text_0: "Tvoje aktuálne heslo",
    zmenahesla_text_1: "Nové heslo",
    zmenahesla_text_2: "8 znakov",
    zmenahesla_text_3: "1 veľké písmeno",
    zmenahesla_text_4: "1 číslica",
    zmenahesla_text_5: "Potvrdenie hesla",
    zmenahesla_text_6: "Nové hesla musia byť rovnaké.",
    zmenahesla_text_7: "Zmeniť heslo",
};
